<template>
  <div class="wrapper">
    <!--  Pass all vue-select listeners to parents, ex. search:blur -->
    <template v-if="product.sizes.length">
      <div class="inner-wrapper">
        <v-select
          :options="product.sizes"
          v-model="product.chosenSize"
          v-on="$listeners"
          :placeholder="'product_page.titles.choose_size' | translate"
          class="sizes"
          ref="sizeSelect"
        ></v-select>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "productSizeSelect",
  props: { product: Object },
  methods: {
    select() {
      this.$refs.sizeSelect.select();
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.wrapper {
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  top: 0;
  z-index: 1;
  height: 100vh;
  width: 100%;

  &::after {
    background-color: gray;
    opacity: 0.3;
    content: "";
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.sizes {
  z-index: 2;
  background-color: $brand-white;
  width: 100%;
}

.inner-wrapper {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>

<style lang="scss">
@import "~@/styles/global.scss";
.v-select.sizes {
  padding: 0;
  cursor: pointer;

  .vs__dropdown-toggle {
    border-radius: 0;
    padding: 0.5rem;
    position: relative;
    border-width: 2px;

    .vs__search {
      font-family: "Montserrat";
      text-align: center;
      font-weight: 500;
      color: $brand-gray-medium;
      font-size: $font-sm;
      margin: 0;
    }

    .vs__actions {
      position: absolute;
      right: 0.5rem;
      top: 0.5rem;
    }
  }

  .vs__dropdown-menu {
    position: relative !important;
  }
}
</style>
